$(() => {
  if (/Edge|Trident\/\d./i.test(navigator.userAgent)) {
    $(document.documentElement).addClass("ie")
  }

  if (window.safari !== undefined) {
    try {
      const safariVersion = navigator.userAgent
        .split(" ")
        .find((el) => el.startsWith("Version"))
        ?.split("/")
        .pop()
      if (parseFloat(safariVersion) < 17) {
        $(document.documentElement).addClass("safari_legacy")
      }
    } catch (error) {
      Bugsnag.notify(error)
    }
  }
})
